import { useLayoutEffect, useRef } from 'react';
import { MOTION } from 'styles/tokens';
import { ResolvedTheme, THEME_TRANSITION_ATTRIBUTE } from './constants';

// Colours cross-fade for one motion step after a theme change (CSS in base/_base.scss keyed on the
// attribute); the first paint and reduced-motion users switch instantly. A layout effect declared
// before the one that flips `data-theme`: the transition has to be on when the colours change.
export const useThemeCrossFade = (resolvedTheme: ResolvedTheme, isReducedMotion: boolean) => {
  const previousThemeRef = useRef(resolvedTheme);

  useLayoutEffect(() => {
    if (previousThemeRef.current === resolvedTheme) {
      return undefined;
    }

    previousThemeRef.current = resolvedTheme;

    if (isReducedMotion) {
      return undefined;
    }

    const root = document.documentElement;
    root.setAttribute(THEME_TRANSITION_ATTRIBUTE, '');
    const timer = window.setTimeout(
      () => root.removeAttribute(THEME_TRANSITION_ATTRIBUTE),
      MOTION.duration.slow,
    );

    return () => {
      window.clearTimeout(timer);
      root.removeAttribute(THEME_TRANSITION_ATTRIBUTE);
    };
  }, [resolvedTheme, isReducedMotion]);
};
